'use client';

import { setBetaCookie } from '@shared/utils';
import { useEffect } from 'react';

function BetaCookieSetter() {
  useEffect(() => {
    setBetaCookie();
  }, []);

  return null;
}

export { BetaCookieSetter };
